import React, { useState } from "react";
import { X, Bug, List, Loader2, Send } from "lucide-react";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../../config/firebase";
import { appId, API_URL } from "../../config/constants";

const ReportModal = ({ user, userData, onClose, onShowHistory }) => {
    const [category, setCategory] = useState("error");
    const [content, setContent] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async () => {
        if (!content.trim()) { alert("請填寫回報內容"); return; }
        setSubmitting(true);
        
        const realName = userData?.name || user?.email?.split('@')[0] || "學生";

        try {
            await addDoc(collection(db, "artifacts", appId, "public", "data", "issues"), {
                userId: user.uid,
                email: user.email,
                userName: realName, 
                type: category,
                description: content,
                status: "open",
                timestamp: serverTimestamp()
            });

            try {
                await fetch(API_URL, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        action: "notify",
                        type: "issue",
                        name: realName, 
                        email: user.email,
                        description: `【${category}】${content}` 
                    })
                });
            } catch (tgErr) {
                console.warn("通知發送微恙:", tgErr);
            }

            alert("✅ 感謝您的回報！我們會盡快處理。");
            onClose();
        } catch (e) {
            console.error("Report Error:", e);
            alert("發送失敗，請稍後再試。");
        } finally {
            setSubmitting(false);
        }
    };

    return (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-in fade-in" onClick={onClose}>
        <div className="bg-white rounded-[2rem] w-full max-w-sm overflow-hidden shadow-2xl relative" onClick={e => e.stopPropagation()}>
          <div className="bg-slate-900 p-6 text-white relative">
              <button onClick={onClose} className="absolute top-4 right-4 p-2 bg-white/10 rounded-full hover:bg-white/20 transition-all"><X size={18}/></button>
              <div className="flex items-center gap-3">
                  <Bug size={24} className="text-orange-400"/>
                  <h3 className="text-xl font-black tracking-wide">問題回報</h3>
              </div>
          </div>
          <div className="p-6 space-y-4">
              <button onClick={() => { onClose(); onShowHistory(); }} className="w-full py-2 bg-slate-100 text-slate-500 font-bold rounded-xl hover:bg-slate-200 transition-all flex items-center justify-center gap-2 text-sm mb-2 border border-slate-200">
                  <List size={16}/> 查看我的回報紀錄
              </button>

              <div className="h-px bg-slate-100 my-2"></div>

              <div>
                   <label className="text-xs font-bold text-slate-500 mb-1 block">問題類別</label>
                  <select value={category} onChange={e => setCategory(e.target.value)} className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl font-bold text-slate-700 outline-none focus:border-orange-400">
                      <option value="error">功能異常 (Bug)</option>
                      <option value="content">解題內容錯誤</option>
                      <option value="suggestion">功能建議</option>
                      <option value="other">其他問題</option>
                  </select>
              </div>
              <div>
                  <label className="text-xs font-bold text-slate-500 mb-1 block">詳細描述</label>
                  <textarea value={content} onChange={e => setContent(e.target.value)} className="w-full h-32 p-3 bg-slate-50 border border-slate-200 rounded-xl font-medium text-slate-700 outline-none focus:border-orange-400 resize-none" placeholder="請詳細描述您遇到的問題..."></textarea>
              </div>
              <button onClick={handleSubmit} disabled={submitting} className="w-full py-3 bg-slate-900 text-white font-bold rounded-xl hover:bg-slate-800 transition-all active:scale-95 flex items-center justify-center gap-2">
                  {submitting ? <Loader2 className="animate-spin" size={20}/> : <><Send size={18}/> 送出回報</>}
              </button>
          </div>
        </div>
      </div>
    );
};

export default ReportModal;
